import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { GenerateGroupsQuickNavMenu } from '../../../global/constants/navigation-lists';
import { institutionBarStyles } from '../../../global/constants/theme/styles/components/institution-bar';
import { useBasePath } from '../../../global/hooks/useBasePath';
import { NavigationContext } from '../../../global/models/app-context-model';
import { TcsmSiteSettingsProps } from '../../../global/models/epi-model';
import { TcsmStates } from '../../../root/tcsm-model';
import { ArcRoutes } from '../constants/routes';
import { GroupsState } from '../features/groups/groups-model';
import { SearchProps } from '../models/arc-epi-props';

interface GroupInfoProps {
	basePath: string,
}

export function GroupInfoHeader(props: GroupInfoProps) {

	const classes = institutionBarStyles();
	const location = useLocation();
	const groupsState = useSelector<TcsmStates, GroupsState>(state => state.groupsState);
	const searchSettings = useSelector<TcsmStates, SearchProps>(state => state.epiProps?.searchSettingsState?.epiContent);
	const language = useSelector<TcsmStates, string>(state => state.globalization.currentlanguage);
	const siteSettings = useSelector<TcsmStates, TcsmSiteSettingsProps>(state => state.epiProps?.siteSettingsState?.siteSettings);
	const navOptions = GenerateGroupsQuickNavMenu(props.basePath, language, siteSettings);
	const pathName = location.pathname.toLocaleLowerCase();
	const groupSearchPath = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.GroupsLanding}${ArcRoutes.GroupSearch}`);

	const userNavigationContext = useSelector<TcsmStates, NavigationContext>(state => state.appContext.userNavigationContext);

	if ((userNavigationContext !== NavigationContext.GroupAdmin) || !groupsState?.currentGroup?.group_id || navOptions.some(nav => pathName?.includes(nav.value)) || location?.pathname?.includes(ArcRoutes?.Participants)) return null;

	return (
		<div className={classes.institutionBarContainer}>
			<p className='input-label institution-bar-number'>{searchSettings?.billingAccountGroupIdLabel}: {groupsState?.currentGroup?.group_id}</p>
			<div className='institution-bar-inner'>
				<p className='institution-bar-name'>{groupsState?.currentGroup?.name}</p>
				<Link to={groupSearchPath}>{searchSettings?.changeGroupContextButtonText || 'Change Benefit Group'}</Link>
			</div>
		</div>
	);
}